import { Event, Color, Property, createPropertyDescriptor, Material, defined } from 'cesium';
import img from './assets/colors2.png';

class PolylineTrailMaterialProperty {
    constructor(option = {}) {
        this._definitionChanged = new Event();
        this._color = undefined;
        this._colorSubscription = undefined;
        this._time = new Date().getTime();

        this.color = option.color ? option.color : Color.fromCssColorString('rgba(90, 90, 255, 1)');
        this.duration = option.duration ? option.duration : 5000;
        this.trailImage = option.trailImage ? option.trailImage : img;

        // 类型（会自动加载到 cesium 中）
        this.type = option.type ? option.type : 'PolylineTrail';

        // 着色器
        this.source = option.source
            ? option.source
            : `
    czm_material czm_getMaterial(czm_materialInput materialInput)
      {
        czm_material material = czm_getDefaultMaterial(materialInput);
        vec2 st = materialInput.st;
        vec4 colorImage = texture2D(image, vec2(fract(st.s - time), st.t));
        material.alpha = colorImage.a * color.a;
        material.diffuse = (colorImage.rgb+color.rgb)/2.0;
        return material;
      }
    `;
        this.addMaterial();
    }

    getType() {
        return 'PolylineTrail';
    }

    getValue(time, result) {
        let _result = result;
        if (!defined(_result)) {
            _result = {};
        }

        _result.color = Property.getValueOrClonedDefault(
            this._color,
            time,
            Color.WHITE,
            _result.color,
        );
        _result.image = this.trailImage;
        _result.time = ((new Date().getTime() - this._time) % this.duration) / this.duration;

        return _result;
    }

    equals(other) {
        return (
            this === other ||
            (other instanceof PolylineTrailMaterialProperty &&
                Property.equals(this._color, other._color))
        );
    }

    addMaterial() {
        Material._materialCache.addMaterial(this.type, {
            fabric: {
                type: this.type,
                uniforms: {
                    color: new Color(1.0, 0.0, 0.0, 0.5),
                    image: this.trailImage,
                    time: 100,
                },
                source: this.source,
            },

            translucent: () => {
                return true;
            },
        });

        // 注意 defineProperties 会报错，需要改为 Object
        Object.defineProperties(PolylineTrailMaterialProperty.prototype, {
            isConstant: {
                get: () => {
                    return false;
                },
                configurable: true,
            },
            definitionChanged: {
                get: () => {
                    return this._definitionChanged;
                },
                configurable: true,
            },
            color: {
                value: createPropertyDescriptor('color'),
                configurable: true,
                writable: true,
            },
        });
    }
}

export default PolylineTrailMaterialProperty;
